// react-bootstrap imports
import { Link } from "react-router-dom"

export function ServiceSectionLegado({ data, destiny })
{
    const { servicos, tipoServico } = data
    const sectionStyle = "d-flex flex-column bg-white m-2 p-3 border border-dark rounded-5 shadow"

    const LinksServicos = ({servicos}) => 
    {
        const servStyle = "btn btn-primary rounded-5 fs-6 shadow border border-primary"
        return (
            <div id={tipoServico} className="d-grid gap-3 ">
                {servicos.map(serv => <Link id={serv.idServ} state={serv.idServ} className={servStyle} to={destiny} key={serv.idServ}>{serv.nomeServ}</Link>)}
            </div>
        )
    }

    return (
        <div id={tipoServico} className={sectionStyle} style={{width:"300px"}}>
            <p className="fw-bold fs-6 my-1 align-self-center">{tipoServico}</p>
            <hr className="border border-dark align-self-center" style={{width: "90%"}} />
            <LinksServicos servicos={servicos} />
        </div>
    )
}